module.exports = __webpack_public_path__ + "static/media/metro5.fb8f4f3b.jpg";